import React from 'react'
import { api, use } from 'xadmin'
import { C, Icon, lazy } from 'xadmin-ui'
import { Card, Typography } from 'antd'
import UploadButton from './UploadButton'
import ValueEditor from './ValueEditor'
import _ from 'lodash'
import { effects } from 'redux-saga'
const { all, put, select, takeEvery } = effects

const JSONEditor = lazy(() => import('./JSONEditor'))

const handle_save_variable = function* () {
  const { _t } = app.context
  const variable = yield api({ name: 'core/systemVariable' }).save(payload)
  yield put({ type: '@@iot/SAVE_VARIABLE', payload: variable, success: true })

  yield put({
    type: '@@xadmin/ADD_NOTICE', payload: {
      type: 'success', headline: _t('Success'), message: '系统变量保存成功'
    }
  })
}

const handle_login = function* () {
  const variable = yield api({ name: 'core/systemVariable' })
    .query({ fields: ['value'] })
    .then(({ items }) => {
      const variable = items.reduce((prev, curr) => ({ ...prev, [curr.name]: curr.value }), {})
      return variable
    })
  yield put({ type: '@@iot/SAVE_VARIABLE', payload: variable, success: true })
}

export default {
  name: 'iot.systemvar',
  menuItems: [
    { title: '数据字典', parent: 'business', url: '/app/model/systemVariable/list', icon: 'Log', permission: 'systemvariable.view' }
  ],
  hooks: {
    'variable': props => {
      const { variable, dispatch } = use('redux', state => ({ variable: state.variable }))
      const saveVariable = variable => React.useCallback(() => dispatch({ type: '@@iot/SAVE_VARIABLE', payload: variable }), [])
      return { variable, saveVariable }
    }
  },
  reducers: {
    variable: (state = {}, { type, payload, success }) => {
      if (type == '@@iot/SAVE_VARIABLE' && payload && success) {
        return { ...state, ...payload }
      }
      return state
    }
  },
  effects: (app) => function* () {
    yield all([
      takeEvery(action => action.type == '@@xadmin/LOAD_VARIABLE', handle_login),
      takeEvery(action => action.type == '@@iot/SAVE_VARIABLE' && !action.success, handle_save_variable)
    ])
  },
  components: {
    JSONEditor
  },
  frontMenuItems: [
    { title: '数据字典', url: '/app/model/systemVariable/list', icon: 'Log', permission: 'systemvariable.view' }
  ],
  models: {
    systemvariable: {
      name: 'systemvariable',
      resource: 'core/systemVariable',
      type: 'object',
      icon: <Icon svg={require('../../icon/Log.svg')} />,
      title: '数据字典',
      properties: {
        name: {
          type: 'string',
          title: '名称'
        },
        uid: {
          type: 'string',
          title: '编号',
          description: '编号必须为汉字、字母、数字、特殊字符!@$-_:'
        },
        type: {
          type: 'string',
          title: '类型',
          enum: ['number', 'string', 'boolean', 'date', 'object', 'array'],
          enum_title: ['数字', '字符串', '布尔值', '日期', '对象', '数组'],
        },
        value: {
          type: 'object',
          title: '值',
          properties: {}
        }
      },
      filters: {
        submenu: ['name'],
      },
      blocks: {
        'model.list.navbtn': (props) => <UploadButton title="导入变量" />,
      },
      forceGetItem: true,
      permission: {
        view: true,
        add: true,
        edit: true,
        delete: true
      },
      required: ['name', 'uid', 'type', 'value'],
      listFields: ['name', 'uid', 'type', 'value'],
      fieldRender: {
        value: ({ item: { type }, value, schema }) => {
          if (_.isNil(value)) {
            return <Typography.Text type="secondary">空</Typography.Text>
          }
          if (type == 'string') {
            if (_.isString(value)) return value
            return JSON.stringify(value)
          } else if (type == 'number') {
            if (_.isNumber(value)) return value
            return JSON.stringify(value)
          } else if (type == 'date') {
            if (_.isString(value)) return value
            return JSON.stringify(value)
          } else if (type == 'boolean') {
            return <C is="Model.BooleanIcon" value={value} schema={schema} />
          } else if (type == 'object' || type == 'array') {
            return <pre style={{ margin: '-5px 0', fontSize: '.8rem' }}>{JSON.stringify(value, 0, 2)}</pre>
          } else {
            return value.toString()
          }
        }
      },
      form: ['name', {
        key: 'uid',
        validate: value => {
          return (/^[0-9]*$/ig.test(value) ? '不能为纯数字' : null)
        }
      }, 'type', {
          key: 'value', component: ValueEditor, validate: (v) => (v?.value == undefined || v?.value === '' || v?.value === null) && '当前为必填项'
        }],
      orders: { createTime: 'DESC' },
      components: {
        DataForm: ({ item, ...props }) => {
          const { dispatch } = use('redux')
          const { saveItem } = use('model.save', props)

          const onSubmitSuccess = () => {
            const name = props?.item?.name
            const value = props?.item?.value
            dispatch({ type: '@@iot/SAVE_VARIABLE', payload: { [name]: value }, success: true })
          }

          return (<C is="Model.DataForm"
            item={item ? { ...item, value: { value: item.value } } : item}
            onSubmit={(item) => saveItem({ ...item, value: item.value?.value })}
            {...props} onSubmitSuccess={onSubmitSuccess} />)
        },
        DataEmpty: props => <Card><C is="NoData" /></Card>
      }
    }
  }
}
